import { useState } from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/free-solid-svg-icons';
import { Sun, Moon } from 'lucide-react';
import SupportChat from './SupportChat';
import '../assets/css/floating-buttons.css';

const FloatingButtons = ({ darkMode, toggleTheme }) => {
  const [supportChatOpen, setSupportChatOpen] = useState(false);

  return (
    <>
      <div className="floating-buttons-container">
        {/* Theme Toggle Button */}
        <motion.div
          className="floating-btn theme-toggle-btn"
          onClick={toggleTheme}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          animate={{ rotate: darkMode ? 180 : 0 }}
          transition={{ duration: 0.3 }}
          title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
        >
          <motion.span
            animate={{ opacity: [0.7, 1, 0.7] }}
            transition={{
              duration: 2,
              repeat: Infinity,
              repeatType: "reverse"
            }}
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            {darkMode ? <Moon size={22} /> : <Sun size={22} />}
          </motion.span>
        </motion.div>

        {/* Support Button */}
        <motion.div
          className="floating-btn support-btn"
          onClick={() => setSupportChatOpen(true)}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          title="Get Support"
        >
          <FontAwesomeIcon icon={faComment} />
        </motion.div>
      </div>

      {/* Support Chat Modal */}
      <SupportChat
        isOpen={supportChatOpen}
        onClose={() => setSupportChatOpen(false)}
      />
    </>
  );
};

export default FloatingButtons;
